import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { getMemberRegistrationStatusByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { useLocation } from "react-router-dom";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import SanjeevaniForm from "../SanjeevaniYojna/SanjeevaniForm";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { getConfigValues } from "../../Helpers/APIEndPoints/EndPoints";
import DepositeStatementGrid from "../SanjeevaniYojna/DepositeStatementGrid";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { IDepositeGridFilters } from "../SanjeevaniYojna/Grid/SanjeevaniGrid";
import "./SanjivanSuvidha.css";
import WithdrawStatmentGrid from "../SanjeevaniYojna/WithdrawStatmentGrid";
import BenefitSanjeevani from "../SanjeevaniYojna/BenefitSanjeevani";
import { AppModules } from "../../Helpers/Enums/AppModules";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      aria-disabled={false}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// This tab is use for both Sanjeevani and Suvidha
const SanjeevaniTabs = (props) => {
  const { state } = useLocation();
  const { appModule } = props;
  // const tabIn = state?.tabIndex;
  const [value, setValue] = React.useState(0);
  const [visible, setVisible] = React.useState(true);
  const [tabsStatus, setTabsStatus] = React.useState([
    false,
    false,
    false,
    false,
  ]);
  const [previous, setPrevious] = React.useState(false);
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const context = getContext();
  const isAdmin = context?.CurrentRoleId === RoleEnum.Admin;
  const isMember = context?.CurrentRoleId === RoleEnum.Member;
  const { previousTab, next } = props;
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] =
    useState<IDepositeGridFilters>(null);
  const [dataCount, setDataCount] = useState(0);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [searchText, setSearchText] = useState("");

  const selectNextTab = (index: any) => {
    // getMemberIdStatusDetails().finally(() => {
    let val = value + 1;
    setValue(val);
    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
    // });
  };

  const selectNextTab2 = () => {
    if (appModule === AppModules.SuvidhaYojna) {
      setValue(2);
    } else if (appModule === AppModules.SanjeevaniYojana) {
      setValue(3);
    }
  };

  const selectPreviousTab = (index: any) => {
    setValue(value - 1);

    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
  };

  // const activeStep = () => {
  //   if (
  //     state?.IsMemberWitnessDetail == false &&
  //     state?.IsMemberPersonalDetail == true
  //   ) {
  //     setValue(1);
  //     setTabsStatus([true, true, true]);
  //   } else if (state?.IsMemberEmployementDetail === false) {
  //     setValue(2);
  //     setTabsStatus([true, true]);
  //   } else if (state?.IsMemberNomineeDetail == false) {
  //     setValue(3);
  //     setTabsStatus([true, true, true, true]);
  //   }
  // };

  const tabs = [
    {
      label: "HOME",
      value: { ...a11yProps(0) },
      disabled: tabsStatus[0],
    },
    {
      label: "DEPOSIT",
      value: { ...a11yProps(1) },
      disabled: tabsStatus[1],
    },
    {
      label: "WITHDRAW REQUEST",
      value: { ...a11yProps(2) },
      disabled: tabsStatus[2],
    },
    {
      label: "STATEMENT",
      value: { ...a11yProps(3) },
      disabled: tabsStatus[3],
      // active: true,
    },
  ];

  const enableTabs = (id) => {
   
    if (id) {
      let tempData = tabsStatus.map((ts, i) => id.includes(i));

      setTabsStatus(tempData);
    }
  };

  const filteredTabs = tabs.filter((tab) => {
    if (isAdmin) {
      return tab.label === "DEPOSIT";
    } else if (appModule === AppModules.SanjeevaniYojana && isMember) {
      return true;
    } else if (appModule === AppModules.SuvidhaYojna && isMember) {
      return tab.label !== "WITHDRAW REQUEST";
    }
    return true;
  });

  useEffect(() => {
    setValue(0);
  }, [appModule]);

  return (
    <Box sx={{ width: "100%" }}>
      <ButtonTabs
        value={value}
        handleChange={handleChange}
        tabs={filteredTabs}
      />

      {filteredTabs.map((tab, index) => {
      

        return (
          <CustomTabPanel key={index} value={value} index={index}>
            {tab.label === "HOME" && (
              <BenefitSanjeevani appModule={appModule} />
            )}

            {tab.label === "DEPOSIT" && (
              <SanjeevaniForm
                appModule={appModule}
                selectNextTab2={selectNextTab2}
                selectPreviousTab={selectPreviousTab}
              />
            )}

            {tab.label === "WITHDRAW REQUEST" && (
              <CustomTabPanel value={value} index={index}>
                <WithdrawStatmentGrid
                  selectNextTab={() => selectNextTab(index)}
                  activeTab={true}
                />
              </CustomTabPanel>
            )}

            {tab.label === "STATEMENT" && (
              <CustomTabPanel value={value} index={index}>
                <DepositeStatementGrid activeTab={true} appModule={appModule} />
              </CustomTabPanel>
            )}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
};

export default SanjeevaniTabs;
